<template>
  <div>
    <el-row>
      <el-table :data="tableData" stripe border style="margin-top: 20px">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编号"></el-table-column>
        <el-table-column prop="NAME" label="名称"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="预计生产总数"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实际生产数量">
          <template slot-scope="scope">
            <el-input id="REAL_COUNT" v-model="scope.row.REAL_COUNT" @input.native="change($event, scope.row)"
              oninput="value=value.replace(/[^0-9.]/g,'')" v-if="totalStatus == 2 || totalStatus == 3"></el-input>
            <span v-else>{{ scope.row.REAL_COUNT }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="PRODUCE_DAY"  label="生产日期">
                </el-table-column> -->
        <!-- <el-table-column label="保质期(天)" v-show="totalStatus !== 1">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.EXPIRATION_DAY"  v-if="totalStatus == 2|| totalStatus == 3" placeholder="请输入保质天数" style="width: 100%" clearable></el-input>
                        <span  v-else>{{scope.row.EXPIRATION_DAY}}</span>
                    </template>
                </el-table-column> -->
        <el-table-column label="操作" v-if="totalStatus == 1">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.row)">修改预计生产数量</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="small" @click="submitAll" style="margin-top: 20px" v-if="totalStatus == 2 || totalStatus == 3">
          完成生产</el-button>
        <el-button size="small" @click="startProduce" style="margin-top: 20px" v-if="totalStatus == 1">开始生产</el-button>
        <el-button size="small" @click="openProduce" style="margin-top: 20px" v-if="Number(totalStatus) !== 1">查看生产明细
        </el-button>
        <el-button size="small" @click="enterStock" style="margin-top: 20px" v-if="totalStatus == 3">确认入库</el-button>
      </el-col>
    </el-row>
    <el-dialog title="修改生产数量" center :visible.sync="changeFormVisible" width="450px">
      <el-form :model="changeForm" ref="changeForm" :rules="rules">
        <el-form-item label="生产数量：" :label-width="formLabelWidth" prop="PRODUCT_COUNT" required>
          <el-input v-model="changeForm.PRODUCT_COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitChange('changeForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';
import { getFormatDay } from '@/assets/common/common';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        date: getFormatDay(0, '-'),
      },
      changeFormVisible: false,
      changeForm: {},
      rules: {
        PRODUCT_COUNT: [
          { required: true, message: '请填写实际生产份数', trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
      totalStatus: sessionStorage.getItem('totalStatus'),
    };
  },
  methods: {
    openEdit(row) {
      this.changeFormVisible = true;
      this.changeForm = row;
    },
    change(e, row) {
      row.REAL_COUNT = e.target.value;
    },
    close() {
      this.changeFormVisible = false;
      this.changeForm = {};
    },
    queryTable(e) {
      const params = {
        SERVICE_ID: '12001',
        OTYPE: 3,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: sessionStorage.getItem('totalId'),
      };
      http.post(params).then((result) => {
        this.tableData = result.map((item) => Object.assign(item, { PRODUCE_DAY: date(new Date(), '%F') }, { EXPIRATION_DAY: 7 }));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitChange() {
      const params = {
        SERVICE_ID: '12001',
        OTYPE: 4,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: sessionStorage.getItem('totalId'),
        DETAIL_ID: this.changeForm.ID,
        PRODUCT_COUNT: this.changeForm.PRODUCT_COUNT,
      };
      http.post(params).then((result) => {
        this.changeFormVisible = false;
        this.changeForm = {};
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    startProduce() {
      const params = {
        SERVICE_ID: '12001',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: sessionStorage.getItem('totalId'),
        CKS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '转换成功', type: 'success' });
        this.queryTable();
        this.$router.push({ name: 'totalSellProducts' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitAll() {
      const flag = this.tableData.find((item) => {
        if (!item.REAL_COUNT) {
          return true;
        }
      });
      if (flag) {
        this.$message.show({ text: '请输入实际生产数量', type: 'warning' });
        return false;
      }
      const submitArr = this.tableData.map((item) => ({ DETAIL_ID: item.ID, REAL_COUNT: item.REAL_COUNT }));
      const params = {
        SERVICE_ID: '12001',
        OTYPE: 6,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: sessionStorage.getItem('totalId'),
        PRODUCT_ARRAY: submitArr,
      };
      http.post(params).then((result) => {
        this.$router.push({ name: 'totalSellProducts' });
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable(e - 1);
    },
    openProduce(row) {
      this.$router.push({ name: 'produceDetail' });
    },
    enterStock() {
      let tmpStockArr = [];
      tmpStockArr = this.tableData.map((item) => ({ ORDER_DETAIL_ID: item.ID, PRODUCTION_DATE: item.PRODUCE_DAY, EXPIRATION_DAY: Number(item.EXPIRATION_DAY) }));
      console.log(tmpStockArr);
      const params = {
        SERVICE_ID: '12001',
        OTYPE: 8,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.tableData[0].ORDER_ID,
        PRODUCT_ARRAY: tmpStockArr,
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '操作成功',
          type: 'success',
        });
        this.$router.push({ name: 'totalSellProducts' });
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/sellProductsDetail.vue